import { Button, CircularProgress, Grid2, Paper, TextField } from "@mui/material";
import Wrapper from "../components/Wrapper"
import { useEffect, useState } from "react";
import { enqueueSnackbar } from "notistack";
import { useParams } from "react-router-dom";
import PageLoader from "../components/PageLoader";
import Editor from "../components/Editor";
import { addModality, getModality, updateModality } from "../services/modality";

const ModalityForm = () => {

  const [title, set_title] = useState('');
  const [summary, set_summary] = useState('');
  const [details, set_details] = useState('');
  const [is_saving, set_is_saving] = useState(false);
  const [is_loading, set_is_loading] = useState(false);

  const params = useParams();

  const modality_id = params.id;

  const handleSave = async () => {
    set_is_saving(true);

    let data_obj = null;

    const detail_obj = {
      title : title,
      summary : summary,
      details : details
    }

    if(modality_id){
      const {data} = await updateModality({
        data : detail_obj,
        id : modality_id
      })
      
      data_obj = data;
    }else{
      const {data} = await addModality(detail_obj)

      set_title('');
      set_summary('');
      set_details('');

      data_obj = data;
    }
    
    set_is_saving(false)

    if(data_obj && data_obj.success){
      enqueueSnackbar('Modality saved successfully !', {
        variant : 'success'
      });
    }else{
      enqueueSnackbar('Error while saving modality !', {
        variant : 'error'
      });
    }
  }

  useEffect(() => {
    if(modality_id){
      getData();
    }
    // eslint-disable-next-line
  }, [modality_id])

  const getData = async () => {
    set_is_loading(true);
    const {data} = await getModality({
      id : modality_id
    });

    set_is_loading(false);

    if(data && data.success){
      set_title(data.data.title);
      set_summary(data.data.summary);
      set_details(data.data.details);
    }
  }

  return(
    <Wrapper>
      <PageLoader
        show={is_loading}
      />
      <Paper
        sx={{
          padding : '20px'
        }}
      >
        <Grid2
          container
          spacing={3}
        >
          <Grid2 size = {3}>
            <TextField
              fullWidth
              label="Title"
              value={title}
              onChange={(e) => set_title(e.target.value)}
            />
          </Grid2>

          <Grid2 size = {9}>
            <TextField
              multiline
              fullWidth
              label="Summary"
              value={summary}
              onChange={(e) => set_summary(e.target.value)}
              rows={3}
            />
          </Grid2>

          <Grid2 size = {12}>

            <Editor
              value={details}
              onChange={set_details}
            />
          </Grid2>

          <Grid2
            size = {12}
            display='flex'
            justifyContent='flex-end'
          >
            <Button
              variant="contained"
              disabled = {
                is_saving ||
                !Boolean(title) ||
                !Boolean(summary) ||
                !Boolean(details)
              }
              onClick={handleSave}
            >
              {
                is_saving ?
                <CircularProgress
                  color="inherit"
                  size='20px'
                />
                : "Save"
              }
            </Button>
          </Grid2>
        </Grid2>
      </Paper>
    </Wrapper>
  )
}

export default ModalityForm;